import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DashboardComponent } from './dashboard/dashboard.component';
import { LoginComponent } from "./login/login.component";
import { AuthGuard } from "./shared/auth/auth.guard";
import { ViewComponent } from './view/view.component';

const routes: Routes = [
  { path: '',                             redirectTo: '/dashboard', pathMatch: 'full' },
  { path: 'login',                        component: LoginComponent , canActivate: [AuthGuard]},
  { path: 'dashboard',                    component: DashboardComponent , canActivate: [AuthGuard]},
  { path: 'view',                         component:     ViewComponent } ,
  { path: 'administrativo',               loadChildren: () => import('../app/administrativo/administrativo.module').then(m => m.AdministrativoModule), canActivate: [AuthGuard]} ,
  { path: 'comercial',                    loadChildren: () => import('../app/comercial/comercial.module').then(m => m.ComercialModule),canActivate: [AuthGuard]},
  { path: 'financeiro',                   loadChildren: () => import('../app/financeiro/financeiro.module').then(m => m.FinanceiroModule),canActivate: [AuthGuard]},

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {

}
